import { createContext, useContext, useState, useCallback } from 'react';
import { LoadingOverlay } from '../components/LoadingOverlay';

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const showLoading = useCallback(() => setLoading(true), []);
  const hideLoading = useCallback(() => setLoading(false), []);

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading }}>
      {children}
      <LoadingOverlay visible={loading} />
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const ctx = useContext(LoadingContext);
  // Retorna fallback seguro se usado fora do provider
  return ctx ?? { showLoading: () => {}, hideLoading: () => {} };
}
